import { render, staticRenderFns } from "./listOweFeeList.vue?vue&type=template&id=6c807f12&scoped=true"
import script from "./listOweFeeList.vue?vue&type=script&lang=js"
export * from "./listOweFeeList.vue?vue&type=script&lang=js"
import style0 from "./listOweFeeList.vue?vue&type=style&index=0&id=6c807f12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c807f12",
  null
  
)

export default component.exports